<template>
  <div class="home">
    <div class="contene">
      <div class="preview">
        <ul>
          <li>
            <div style="background: #f6919f" class="total">
              <div class="value">{{ latestBlock }}</div>
              <div class="name">区块链高度</div>
              <img src="../assets/区块@2x.png" alt="" />
            </div>
          </li>
          <li>
            <div style="background: #3f479c" class="total">
              <div class="value">{{ txCount }}</div>
              <div class="name">交易</div>
              <img src="../assets/交易@2x.png" alt="" />
            </div>
          </li>
          <li>
            <div style="background: #feb161" class="total">
              <div class="value">{{ peerCount }}</div>
              <div class="name">节点</div>
              <img src="../assets/节点@2x.png" alt="" />
            </div>
          </li>
          <li>
            <div style="background: #9294cd; margin-right: 0px" class="total">
              <div class="value">{{ chaincodeCount }}</div>
              <div class="name">合约</div>
              <img src="../assets/售电合约@2x.png" alt="" />
            </div>
          </li>
        </ul>
      </div>
      <div class="echarts">
        <div class="echart">
          <div id="echarts1"></div>
        </div>
        <div class="echart">
          <div id="echarts2"></div>
        </div>
      </div>
       <div class="echarts">
        <div class="echart">
          <div id="echarts3"></div>
        </div>
        <div class="echart">
          <div id="echarts4"></div>
        </div>
      </div>
      <div class="table">
        <div style="display: flex">
          <div>
            <el-select
              @change="getDataList()"
              v-model="tableType"
              placeholder="请选择表"
              style="
                width: 100px;
                margin-right: 560px;
                margin-left: 20px;
                height: 50px;
              "
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div style="display: flex; align-items: center">
            <el-date-picker
              style="margin-left: 20px"
              v-model="value1"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              popper-class="picker"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
            <el-button
              @click="getDataList()"
              style="
                margin-left: 10px;
                background-color: #9494d3;
                color: #fff;
                border-color: transparent;
                width: 81px;
                height: 50px;
                border-radius: 10px 10px 10px 10px;
                opacity: 1;
              "
              >查询
            </el-button>
          </div>
        </div>
        <el-table
          :data="tableData"
          style="width: 100%; margin: 10px 0px 10px 0px"
        >
          <el-table-column width="20">
            <div class="yuan"></div>
          </el-table-column>
          <el-table-column
            prop="to_user_address"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            label="用户"
            width="180"
          >
          </el-table-column>

          <el-table-column
            prop="token_name"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            label="存证名称"
            width="180"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.token_name.replace(/中钞/g, "融权") }}</span>
            </template>
          </el-table-column>
          <!--                    <el-table-column-->
          <!--                            prop="channelname"-->
          <!--                            header-align="center"-->
          <!--                            align="center"-->
          <!--                            label="通道号"-->
          <!--                            width="180">-->
          <!--                    </el-table-column>-->
          <el-table-column
            prop="chain_tx_id"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            label="交易哈希"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="getTransaction(scope.row.chain_tx_id, scope.row.type)"
                >{{ scope.row.chain_tx_id }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            header-align="center"
            align="center"
            label="类型"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type == '1'">新增</span>
              <span v-if="scope.row.type == '2'">转赠</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
            label="合约名称"
          >
            <template slot-scope="scope">
              <!-- <span>TDAPFXE7EPL4W6EMIRWV2FDLQ4XR4TZF</span> -->
              <span>{{scope.row.contract}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="created_time"
            header-align="center"
            align="center"
            label="时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.created_time | dateFormate }}</span>
            </template>
          </el-table-column>
          <el-table-column
        prop="created_time"
        header-align="center"
        align="center"
        label="销毁状态"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.burn === false">未销毁</span>
          <span v-if="scope.row.burn === true">已销毁</span>
        </template>
      </el-table-column>
        </el-table>
        <el-pagination
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          style="padding: 0 300px"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="交易详情"
      :modal="false"
      :visible.sync="dialogTableVisible"
    >
      <el-descriptions
        title=""
        :column="1"
        border
        v-if="transactionId"
        labelStyle="word-break:keep-all"
      >
        <el-descriptions-item label="交易哈希">
          {{ transactionId }}
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <span v-if="status == 0">待上链</span>
          <span v-if="status == 1">上链成功</span>
          <span v-if="status == 2">上链失败</span>
        </el-descriptions-item>
        <el-descriptions-item label="存证编号"
          >{{ tokenId }}
        </el-descriptions-item>
        <el-descriptions-item label="存证名称"
          >{{ owner.replace(/中钞/g, "融权") }}
        </el-descriptions-item>
        <el-descriptions-item label="时间"
          >{{ createdt | dateFormate }}
        </el-descriptions-item>
        <el-descriptions-item label="存证">
          <img :src="tokenURL" alt="" height="300" />
        </el-descriptions-item>
      </el-descriptions>
      <div v-if="!transactionId">暂无数据</div>
    </el-dialog>
  </div>
</template>

<script>
import "../assets/datePicker.scss";
import * as echarts from "echarts";
import JsonViewer from "vue-json-viewer";
import Clipboard from "clipboard";

export default {
  components: {
    JsonViewer,
  },
  data() {
    return {
      value1: [],
      token: "",
      currentChannel: "",
      chaincodeCount: 0,
      latestBlock: 0,
      peerCount: 0,
      txCount: 0,
      echarts1Lable: [],
      echarts1Date: [],
      echarts2Lable: [],
      echarts2Date: [],
      echarts3Lable: [],
      echarts3Date: [],
      echarts4Lable: [],
      echarts4Date: [],
      pieData: [],
      legendData: [],
      tableData: [],
      dialogTableVisible: false,
      transactionId: "",
      validation_code: "",
      payload_proposal_hash: "",
      creator_msp_id: "",
      endorser_msp_id: "",
      chaincodename: "",
      type: "",
      createdt: "",
      read_set: "",
      write_set: "",
      tokenId: "",
      owner: "",
      tokenURL: "",
      tableType: 1,
      options: [
        {
          value: 1,
          label: "新增",
        },
        {
          value: 2,
          label: "转赠",
        },
      ],
      channelname: "",
      page: 1,
      limit: 10,
      total: 0,
      status: "",
    };
  },
  created() {
    this.start();
    this.lineEcharts1();
    this.lineEcharts2();
    this.lineEcharts3();
    this.lineEcharts4();
    this.getDataList();
  },
  methods: {
    getToken() {
      // console.log(this.$http.baseURL)
      this.$http
        .post(this.$http.baseURL + "/auth/login", {
          network: "test-network",
          password: "exploreradminpw",
          user: "exploreradmin",
        })
        .then((res) => {
          this.token = res.data.token;
          this.getcurrentChannel();
        });
    },
    getcurrentChannel() {
      this.$http
        .get(this.$http.baseURL + "/curChannel", {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.currentChannel = res.data.currentChannel;
          this.start();
          // this.pieEcharts()
        });
    },
    start() {
      this.$http.get(this.$http.baseURL2 + "/blockInfo").then((res) => {
        // this.$http.get("/api2/blockInfo").then((res) => {
        this.chaincodeCount = res.data.chaincodeCount;
        this.latestBlock = res.data.latestBlock;
        this.peerCount = res.data.peerCount;
        this.txCount = res.data.txCount;
      });
    },
    lineEcharts1() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/tradecount")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts1Lable.push(res.data.data.list[n].count);
            this.echarts1Date.push(res.data.data.list[n].days);
          }
          this.getecharts1();
        });
    },
    getecharts1() {
      var chartDom1 = document.getElementById("echarts1");
      var myChart1 = echarts.init(chartDom1);
      var option1;
      var listener1 = function () {
        myChart1.resize();
      };
      window.addEventListener("resize", listener1);
      option1 = {
        title: {
          text: "近14天交易统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts1Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts1Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option1 && myChart1.setOption(option1);
    },
    lineEcharts2() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/usercount")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts2Lable.push(res.data.data.list[n].count);
            this.echarts2Date.push(res.data.data.list[n].days);
          }
          this.getecharts2();
        });
    },
    getecharts2() {
      var chartDom2 = document.getElementById("echarts2");
      var myChart2 = echarts.init(chartDom2);
      var option2;
      var listener2 = function () {
        myChart2.resize();
      };
      window.addEventListener("resize", listener2);
      option2 = {
        title: {
          text: "近14天用户统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts2Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts2Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option2 && myChart2.setOption(option2);
    },
    lineEcharts3() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/collectionscount")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts3Lable.push(res.data.data.list[n].count);
            this.echarts3Date.push(res.data.data.list[n].days);
          }
          this.getecharts3();
        });
    },
    getecharts3() {
      var chartDom3 = document.getElementById("echarts3");
      var myChart3 = echarts.init(chartDom3);
      var option3;
      var listener3 = function () {
        myChart3.resize();
      };
      window.addEventListener("resize", listener3);
      option3 = {
        title: {
          text: "近14天存证统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts3Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts3Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option3 && myChart3.setOption(option3);
    },
    lineEcharts4() {
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/turnoverratecount?transType=2")
        .then((res) => {
          for (let n = 0; n < res.data.data.list.length; n++) {
            this.echarts4Lable.push(res.data.data.list[n].count);
            this.echarts4Date.push(res.data.data.list[n].days);
          }
          this.getecharts4();
        });
    },
    getecharts4() {
      var chartDom4 = document.getElementById("echarts4");
      var myChart4 = echarts.init(chartDom4);
      var option4;
      var listener4 = function () {
        myChart4.resize();
      };
      window.addEventListener("resize", listener4);
      option4 = {
        title: {
          text: "近14天转赠统计",
          subtext: "",
          left: "center",
        },
        xAxis: {
          type: "category",
          data: this.echarts4Date,
          boundaryGap: false,
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "item", // axis   item   none三个值
        },
        series: [
          {
            data: this.echarts4Lable,
            type: "line",
            label: {
              show: true,
            },
          },
        ],
      };

      option4 && myChart4.setOption(option4);
    },
    getDataList() {
      // console.log(this.page)
      this.tableData = [];
      // console.log(this.value1)
      if (!this.value1) {
        this.value1 = [];
      }
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/txlist", {
          params: {
            pageIndex: this.page,
            pageSize: this.limit,
            startTime: this.value1[0],
            endTime: this.value1[1],
            // from: this.dateValue[0],
            // to: this.dateValue[1],
            type: this.tableType,
          },
        })
        .then((res) => {
          this.tableData = res.data.data.items;
          this.total = res.data.data.total;
        });
    },
    sizeChangeHandle(val) {
      console.log(val);
      this.limit = val;
      this.page = 1;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.page = val;
      this.getDataList();
    },
    getTransaction(id, type) {
      this.transactionId = "";
      this.chaincodename = "";
      this.createdt = "";
      this.tokenId = "";
      this.owner = "";
      this.tokenURL = "";
      this.status = "";
      this.$http
        .get(this.$http.baseURL2 + "/nfe/sync/tradinglist", {
          params: {
            chaixTxId: id,
            // type:type
          },
        })
        .then((res) => {
          if (res.data.data) {
            this.transactionId = res.data.data.chain_tx_id;
            this.chaincodename = res.data.data.chaincodename;
            this.createdt = res.data.data.created_time;
            this.tokenId = res.data.data.token_id;
            this.owner = res.data.data.token_name;
            this.tokenURL = res.data.data.token_uri;
            this.status = res.data.data.status;
          } else {
            // this.dialogTableVisible = true
          }
          this.dialogTableVisible = true;
          console.log(this.transactionId);
        });
    },
    clickCopy() {
      new Clipboard(".tag-read").on("success", (e) => {
        // console.log('复制成功')
        new Clipboard(".tag-read").destroy(); // 释放内存
      });
      new Clipboard(".tag-read").on("error", (e) => {
        // console.log('不支持复制,该浏览器不支持自动复制')
        new Clipboard(".tag-read").destroy(); // 释放内存
      });
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  .contene {
    /*background: url("./../assets/previewBG.gif") no-repeat center center;*/
    /*background-size: 100% 100%;*/
    /*background-color: white;*/
    height: 178px;
    // margin: 0 auto 50px auto;
    width: 100%;
    background-color: #fff;
    // background-color: rgba(94, 33, 223, 0.5);
    // background: linear-gradient(top, #7874ff, #dab4fe);

    .preview {
      /*margin: 0 auto 50px auto;*/
      /*max-width: 1200px;*/
      /*padding: 36px;*/

      // margin-top: 20px;
      color: #fff;
      text-align: left;
      margin-bottom: 40px;
      ul {
        display: flex;
        justify-content: center;
        li {
          width: 280px;
          .total {
            height: 120px;
            text-align: center;
            border-radius: 25px 25px 25px 25px;
            opacity: 1;
            margin-right: 13px;
            position: relative;
            .name {
              font-size: 20px;
              font-family: Source Han Sans CN-Light, Source Han Sans CN;
              font-weight: 300;
              color: #ffffff;
              line-height: 0px;
              margin-top: 23px;
            }
            .value {
              margin-top: 36px;
              font-size: 36px;
              font-family: Source Han Sans CN-Medium, Source Han Sans CN;
              font-weight: 500;
              color: #ffffff;
              padding-top: 20px;
            }
            img {
              position: absolute;
              bottom: 0px;
              right: 13px;
              width: 120px;
              height: 120px;
            }
          }
        }
      }
    }

    .echarts {
      max-width: 1200px;
      margin: 10px auto;
      display: flex;

      .echart {
        background: white;
        /*width: 50%;*/
        width: 50%;
        height: 250px;
        margin-right: 10px;
        // padding-top: 20px;

        &:last-child {
          margin-right: 0;
        }

        div {
          width: 100%;
          height: 100%;
        }
      }
    }

    .table {
      background-color: white;
      padding: 10px 0px 0 0px;
      margin: 20px auto;
      max-width: 1200px;
      .el-date-editor--datetimerange.el-input__inner {
        height: 50px;
      }
      .el-range-editor.el-input__inner {
        padding: 0px;
      }
      /deep/ .el-date-editor .el-range-separator {
        line-height: 50px;
      }

      /deep/ .el-select .el-input__inner {
        height: 50px;

      }
      .el-pagination /deep/ .el-select .el-input__inner {
        height: 30px;
      }
      .el-pagination {
        height: 35px;
      }
      /deep/ .el-date-editor .el-range-input {
        height: 18px;
        font-size: 18px;
        font-family: Source Han Sans CN-Light, Source Han Sans CN;
        font-weight: 300;
        color: #bbbbbb;
        margin-left: 20px;
      }

      /deep/ .el-icon-time:before {
        font-size: 22px;
        line-height: 50px;
        padding-left: 20px;
      }
      div {
        text-align: left;
        margin: 10px 0px;
        .el-select {
          /deep/ .el-input--suffix .el-input__inner {
            background-color: #9494d3;
            color: #fff;
          }

          /deep/ .el-input__inner {
            border-color: transparent;
          }
        }

        /deep/ .el-date-editor--datetimerange.el-input__inner {
          border-color: rgba(148, 148, 211, 1);
        }
      }

      .yuan {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background-color: rgba(64, 179, 148, 1);
      }
    }
  }
}
</style>
